<div class="display-flex-with-align-center-and-justify-center">
  <mat-card
    class="login-card display-flex-with-align-center-and-justify-center">
    <mat-card-header class="header-holder">
      <img
        priority
        ngSrc="assets/talentmarket.logo.svg"
        routerLink="/home"
        alt="talentmarket."
        class="logo-card cursor-pointer"
        height="100"
        width="250" />
    </mat-card-header>
    <mat-card-content>
      <mat-tab-group animationDuration="0ms">
        <!-- Email/Password Tab -->
        <mat-tab label="Email">
          <form
            *ngIf="loginFormGroup"
            [formGroup]="loginFormGroup"
            (ngSubmit)="signIn()"
            class="form-holder tab-content">
            <mat-form-field appearance="fill" class="width-full">
              <input
                matInput
                id="email"
                required
                formControlName="email"
                placeholder="Email"
                autocomplete="username" />
            </mat-form-field>
            <mat-error
              *ngIf="
                loginFormGroup.get('email')?.invalid && loginFormGroup.touched
              ">
              Email is required
            </mat-error>
            <mat-form-field appearance="fill" class="width-full">
              <input
                matInput
                id="password"
                required
                [type]="hidePassword ? 'password' : 'text'"
                formControlName="password"
                placeholder="Password"
                autocomplete="current-password" />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hidePassword = !hidePassword">
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>
            <mat-error
              *ngIf="
                loginFormGroup.get('password')?.invalid && loginFormGroup.touched
              ">
              Password is required
            </mat-error>
            <button mat-raised-button color="primary" class="login-btn">
              Login
            </button>
            <div class="forgot-password-link">
              <a routerLink="/forgot-password">Forgot Password?</a>
            </div>
          </form>
        </mat-tab>

        <!-- Phone OTP Tab -->
        <mat-tab label="Phone">
          <div class="form-holder tab-content">
            <!-- Step 1: Enter phone number -->
            <ng-container *ngIf="otpStep === 'phone'">
              <form [formGroup]="phoneFormGroup" (ngSubmit)="requestOtp()">
                <div class="phone-combined-input" [class.focused]="phoneInputFocused">
                  <div class="country-select-wrapper">
                    <div class="country-select" (click)="countryDropdownOpen = !countryDropdownOpen">
                      <img [src]="'https://flagcdn.com/w20/' + selectedCountryCode.toLowerCase() + '.png'"
                           width="20" height="15" alt="" class="flag-icon">
                      <span class="dial-code">{{ selectedDialCode }}</span>
                      <span class="dropdown-arrow">&#9662;</span>
                    </div>
                    <div class="country-dropdown-backdrop" *ngIf="countryDropdownOpen"
                         (click)="countryDropdownOpen = false"></div>
                    <div class="country-dropdown" *ngIf="countryDropdownOpen">
                      <div class="country-dropdown-item"
                           *ngFor="let country of countries"
                           (click)="selectCountry(country)">
                        <img [src]="'https://flagcdn.com/w20/' + country.code.toLowerCase() + '.png'"
                             width="20" height="15" alt="" class="flag-icon">
                        <span>{{ country.name }} ({{ country.dialCode }})</span>
                      </div>
                    </div>
                  </div>
                  <div class="phone-divider"></div>
                  <input
                    class="phone-number-input"
                    formControlName="phoneNumber"
                    placeholder="91 234 5678"
                    autocomplete="tel"
                    (focus)="phoneInputFocused = true"
                    (blur)="phoneInputFocused = false" />
                </div>
                <div class="phone-hint">Enter your phone number to receive a login code</div>
                <div class="otp-error" *ngIf="otpError">{{ otpError }}</div>
                <button
                  mat-raised-button
                  color="primary"
                  class="login-btn"
                  type="submit"
                  [disabled]="phoneFormGroup.invalid || isOtpLoading">
                  <mat-spinner *ngIf="isOtpLoading" diameter="20"></mat-spinner>
                  <span *ngIf="!isOtpLoading">Send Code</span>
                </button>
              </form>
            </ng-container>

            <!-- Step 2: Enter OTP code -->
            <ng-container *ngIf="otpStep === 'otp'">
              <div class="otp-step-container">
                <div class="otp-icon">
                  <mat-icon class="sms-icon">sms</mat-icon>
                </div>
                <div class="phone-display">
                  Code sent to <strong>{{ selectedDialCode }} {{ phoneFormGroup.value.phoneNumber }}</strong>
                </div>
                <form [formGroup]="otpFormGroup" (ngSubmit)="verifyOtp()" class="otp-form">
                  <div class="otp-code-input" [class.focused]="otpInputFocused" [class.error]="otpError">
                    <input
                      formControlName="otpCode"
                      placeholder="------"
                      maxlength="6"
                      autocomplete="one-time-code"
                      (focus)="otpInputFocused = true"
                      (blur)="otpInputFocused = false" />
                  </div>
                  <div class="otp-error" *ngIf="otpFormGroup.get('otpCode')?.hasError('pattern') && otpFormGroup.get('otpCode')?.touched">
                    Code must be exactly 6 digits
                  </div>
                  <div class="otp-error" *ngIf="otpError">{{ otpError }}</div>
                  <button
                    mat-raised-button
                    color="primary"
                    class="login-btn"
                    type="submit"
                    [disabled]="otpFormGroup.invalid || isOtpLoading">
                    Login
                  </button>
                </form>
                <div class="otp-actions">
                  <a
                    class="resend-link"
                    (click)="resendOtp()"
                    [class.disabled]="otpCountdown > 0">
                    {{ otpCountdown > 0 ? 'Resend in ' + otpCountdown + 's' : 'Resend Code' }}
                  </a>
                  <span class="otp-actions-divider">|</span>
                  <a class="back-link" (click)="backToPhone()">Change number</a>
                </div>
              </div>
            </ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
    <mat-card-footer class="login-footer">
      Let's find great candidates!
    </mat-card-footer>
  </mat-card>
</div>
